const leads = {
  ERROR_CUSTOMER_BUSINESS_OPEN: 'El cliente ya tiene un negocio abierto con ese auto. Lead id: {n}',
}

export default leads
